<div fxLayout="row"
     style=" font-size: 22px; font-family: 'Century Gothic', sans-serif; color: var(--primary); margin-top: 50px; margin-bottom: 50px;">
  {{notificationTitle}}
</div>
<div style="margin-left: 18px;" fxFlex.lt-md="100">

  <mat-tab-group #tabs>
    <mat-tab *ngFor="let child of children">


      <!--             Child name and notification badge -->
      <ng-template mat-tab-label>
        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif" fxFlex fxLayoutAlign="start center center">
          <span fxFlex>{{childrenDisplayName(child)}}</span>
        </div>
      </ng-template>
      <div fxLayout="column" fxFlex>
        <div fxLayout="row wrap">
          <div class="consentCard mat-elevation-z5" *ngFor="let consent of child.notifications">

            <div *ngIf="consent.mode === 'consent'" style="height:80px;  padding:10px; background-color: #f7f7f7;">
              <mat-card-title style="font-size:16px;">{{consent.title}}</mat-card-title>
              <mat-card-subtitle style="font-size:14px; margin-top: 5px;">Προθεσμία Υποβολής: &nbsp;<span
                style="font-size:16px; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
              </mat-card-subtitle>
            </div>

            <div *ngIf="consent.mode === 'affirmation'" style="height:80px;  padding:10px; background-color:  #f7f7f7">
              <mat-card-title style="font-size:16px; color: black;">{{consent.title}}</mat-card-title>
              <mat-card-subtitle style="font-size:14px; margin-top: 5px; color: black;">Προθεσμία Υποβολής: &nbsp;<span
                style="font-size:16px; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
              </mat-card-subtitle>
            </div>
            <mat-divider fxLayout="row" style="width: 100%;"></mat-divider>

            <div style="margin:10px 16px 0 16px">
              <div fxLayout="column" style="height:90px;">

                <div fxLayout="column" fxFlex
                     style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                  {{consent.description}}
                </div>
              </div>
            </div>
            <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
              <button (click)="showConsent(consent)" mat-flat-button
                      style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue);">Προβολή
              </button>
            </div>
          </div>

          <div class="consentCard mat-elevation-z1" *ngFor="let announcement of child.announcements">

            <div style="height:80px;  padding:10px; background-color: #f7f7f7;">
              <mat-card-title style="font-size:16px;">{{announcement.title}}</mat-card-title>
            </div>

            <mat-divider fxLayout="row" style="width: 100%;"></mat-divider>

            <div style="margin:10px 16px 0 16px">
              <div fxLayout="column" style="height:90px;">

                <div fxLayout="column" fxFlex
                     style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                  {{announcement.description}}
                </div>
              </div>
            </div>
            <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
              <button mat-flat-button (click)="showAnnouncement(announcement)"
                      style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue);">Προβολή
              </button>
            </div>
          </div>

          <div *ngIf='child.notifications.length + child.announcements.length === 0' style="height:300px;" fxLayout="column" fxFlex fxLayoutAlign="center center center">
            <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>
            <div
              style="font-family: 'Century Gothic', sans-serif; font-weight: normal; font-size: 18px; margin-top:1em;">
              Δεν υπάρχουν διαθέσιμες δηλώσεις προς συμπλήρωση
            </div>
          </div>
        </div>
      </div>


    </mat-tab>
  </mat-tab-group>
</div>

